var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View } from "./view";
import LocalStorageService from "../../services/localStorage";
import { deleteEntityClearData } from "../../store/delete/actions";
import { position, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { useAccountTypeGetAll } from "../../fnx/accountType/accountTypeGetAll";
import { useAccountTypePost } from "../../fnx/accountType/accountTypePost";
import { showErrorToast } from "../../fnx/showError";
import { useAccountTypePatch } from "../../fnx/accountType/accountTypePatch";
import { useTranslation } from "react-i18next";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var AccountTypeAdmin = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _a = useState([]), list = _a[0], setList = _a[1];
    var _b = useState(false), trigger = _b[0], setTrigger = _b[1];
    var _c = useState(false), triggerPost = _c[0], setTriggerPost = _c[1];
    var _d = useState(false), triggerPatch = _d[0], setTriggerPatch = _d[1];
    var _e = useState(""), idAccountType = _e[0], setIdAccountType = _e[1];
    var _f = useState({
        data: { clientId: "" },
    }), bodyRequest = _f[0], setBodyRequest = _f[1];
    var _g = useState(false), openModal = _g[0], setOpenModal = _g[1];
    var _h = useState(false), openModalConfirm = _h[0], setOpenModalConfirm = _h[1];
    var _j = useState(false), openModalCloneConfirm = _j[0], setOpenModalCloneConfirm = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _k = useState(false), isUpdate = _k[0], setIsUpdate = _k[1];
    var _l = useState(null), itemModal = _l[0], setitemModal = _l[1];
    var _m = useState({
        Id: "",
        Name: "",
    }), dataForm = _m[0], setDataForm = _m[1];
    var _o = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _o[0], setSeeToast = _o[1];
    var _p = useAccountTypeGetAll(trigger, clientId), responseAccountType = _p.responseAccountType, errorAccountType = _p.errorAccountType, loadingAccountType = _p.loadingAccountType;
    var _q = useAccountTypePost(triggerPost, bodyRequest), responseAccountTypePost = _q.responseAccountTypePost, errorAccountTypePost = _q.errorAccountTypePost, loadingAccountTypePost = _q.loadingAccountTypePost;
    var _r = useAccountTypePatch(triggerPatch, bodyRequest, idAccountType), responseAccountTypePatch = _r.responseAccountTypePatch, errorAccountTypePatch = _r.errorAccountTypePatch, loadingAccountTypePatch = _r.loadingAccountTypePatch;
    var _s = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _s.responseDeleteEntity, loadingDeleteEntity = _s.loadingDeleteEntity, errorDeleteEntity = _s.errorDeleteEntity;
    var callAccountTypes = function () {
        setTrigger(!trigger);
    };
    useEffect(function () {
        callAccountTypes();
    }, []);
    var callAccountTypePost = function () {
        setTriggerPost(!triggerPost);
    };
    var callAccountTypePatch = function () {
        setTriggerPatch(!triggerPatch);
    };
    useEffect(function () {
        if (responseAccountType && (responseAccountType === null || responseAccountType === void 0 ? void 0 : responseAccountType.length) > 0) {
            var listAccountType = responseAccountType.map(function (item) { return ({
                id: item.id,
                title: item.name,
                clientId: item.clientId,
            }); });
            setList(listAccountType);
        }
    }, [responseAccountType]);
    /*Valida respuesta cuando ya se inserto el registro*/
    useEffect(function () {
        setTriggerPost(false);
        if (responseAccountTypePost) {
            setSeeToast({
                show: true,
                message: "Creado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
        }
        callAccountTypes();
    }, [responseAccountTypePost]);
    /*Muestra si tubo errores el GET ALL de Tipo de Proyectos*/
    useEffect(function () {
        if (errorAccountType) {
            showErrorToast(errorAccountType, setSeeToast, t);
        }
    }, [errorAccountType]);
    /*Muestra si tubo errores el POST de Tipo de Proyectos*/
    useEffect(function () {
        if (errorAccountTypePost) {
            showErrorToast(errorAccountTypePost, setSeeToast, t);
        }
    }, [errorAccountTypePost]);
    /*Muestra si tubo errores el Patch de Tipo de Proyectos*/
    useEffect(function () {
        if (errorAccountTypePatch) {
            showErrorToast(errorAccountTypePatch, setSeeToast, t);
        }
    }, [errorAccountTypePatch]);
    useEffect(function () {
        if (responseDeleteEntity) {
            setSeeToast({
                show: true,
                message: "Eliminado con éxito",
                type: typeAlert.success,
            });
            setOpenModal(false);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            setSeeToast({
                show: true,
                message: errorDeleteEntity === null || errorDeleteEntity === void 0 ? void 0 : errorDeleteEntity.message.message,
                type: typeAlert.error,
            });
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    //// pregunta amilcar 1, en el lado del projectType solo tiene clientId: clientId y no tiene el .row
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { Id: row.id, Name: row.title, clientId: clientId }));
    };
    /*Submit para actualizar o agregar un registro*/
    var handleSubmitAccountType = function (dataProject) {
        if (isUpdate) {
            /*Se llena la informacion al momento de acutalizar*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    clientId: clientId,
                    description: dataProject.Description,
                },
            });
            // Se asigna el id del ProjectType para a actualizar
            setIdAccountType(dataForm.Id);
            /*Llamda al FNX para actualizar PATCH*/
            callAccountTypePatch();
            // setAvatarFile(file);
        }
        else {
            /*Se procede a crear un nuevo Registro*/
            /*Se crea objeto en base al body del api*/
            setBodyRequest({
                data: {
                    clientId: clientId,
                    description: dataProject.Description,
                },
            });
            // setAvatarFile(file);
            /*Llamada al FNX para crear Registro*/
            callAccountTypePost();
        }
        setOpenModal(false);
    };
    var handleOpenModal = function () {
        setOpenModal(true);
    };
    var handleOpenModalConfirm = function () {
        setOpenModalConfirm(true);
    };
    var handleOpenModalCloneConfirm = function () {
        setOpenModalCloneConfirm(true);
    };
    var handleCloseModal = function () {
        setOpenModal(false);
    };
    //pregunta amilcar 2 aqui tengo name y del otro lado no
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenModal(true);
        setDataForm(__assign(__assign({}, dataForm), { Id: "", Name: "", clientId: "", Image: "", Description: "" }));
    };
    // anterior handleOnclickButto
    /*
        const handleOnClickButtonOptionsDropdown = (opt?: any, item?: any) => {
          if (opt.id === "1") {
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(item);
          } else if (opt.id === "2") {
            setitemModal(item);
            setOpenModalConfirm(true);
          } else if (opt.id === "3") {
            setitemModal(item);
            setOpenModalCloneConfirm(true);
          }
        };
      */
    /// nuevo handleOnclickButto
    var handleOnClickButtonOptionsDropdown = function (opt, item) {
        if (opt.id === "1") {
            // Opcion Editar
            setIsUpdate(true);
            setOpenModal(true);
            showEdit(item);
        }
        else if (opt.id === "2") {
            // Opcion eliminar
            // setitemModal(item);
            // setOpenModalConfirm(true);
            setSeeToast({
                show: true,
                message: "Operación no permitida!",
                type: typeAlert.warning,
            });
            setOpenModal(false);
        }
        else if (opt.id === "3") {
            setitemModal(item);
            setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseModalConfirm = function () {
        setOpenModal(false);
        setOpenModalConfirm(false);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    /*Api que se ejecuta cuando el catalogo tiene la opcion
     * para eliminar registros*/
    var handleDelete = function () {
        setSeeToast({
            show: true,
            message: "Operación no permitida!",
            type: typeAlert.warning,
        });
        setOpenModal(false);
    };
    var handleClone = function () { };
    return (_jsxs(React.Fragment, { children: [seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () { setSeeToast({ show: false, message: "", type: typeAlert.success }); }), _jsx(View, { title: "Tipo de cuenta", accountTypeTitle: isUpdate ? "Modificar Tipo Proyecto" : "Agregar Tipo Proyecto", list: list, openModal: openModal, openModalConfirm: openModalConfirm, openModalCloneConfirm: openModalCloneConfirm, loadingPost: null, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, clickView: clickView, onSubmit: handleDelete, onSubmitClone: handleClone, onClose: handleCloseModal, onCloseConfirm: handleCloseModalConfirm, onCloseCloneModal: handleCloseCloneModal, handleOpenModal: handleOpenModal, handleOpenModalConfirm: handleOpenModalConfirm, handleOpenModalCloneConfirm: handleOpenModalCloneConfirm, onSaveData: handleSubmitAccountType, onClickAdd: handleOnClickAdd, onClickButtonOptionsDropdown: function (opt, item) {
                    handleOnClickButtonOptionsDropdown(opt, item);
                } })] }));
};
export default AccountTypeAdmin;
